export default {
    accessories: {
        intro: [
            "Central vacuum systems are built to last for decades, but some components break or wear out with ordinary use. Zimm’s offers a full line of replacement parts for all makes and models of central vacuum systems - including Cyclovac, Vacuflo and Beam. Almost all parts are interchangeable, and can be used with any brand of system.",
            "Additional accessories available for central vacuums make it easy for you to clean any surface and access hard to reach places. Call Zimm's at 248-207-8576 and we will help you find just the right parts for replacement or for an upgrade to your system.",
            "Products may vary slightly from photo as inventory changes. Prices may change without notice."
        ],
        parts: [
            {
                type: "cleaning kits",
                gallery: [
                    { 
                        img: "ck1.png",
                        info: ["Deluxe Electric SEBO Kit", "35’ $695.00"]
                    },
                    { 
                        img: "ck2.png",
                        info: ["Zoom Luxe Premium Kit with Hose Sock", "35’ $495.00"]
                    },
                    // { 
                    //     img: "ck3.png",
                    //     info: ["DECO Turbo Team Cleaning Kit", "35’ $395.00"]
                    // },
                    { 
                        img: "ck4.png",
                        info: ["40’ Garage and Car Care Kit $160.00"]
                    },
                    { 
                        img: "ck5.png",
                        info: ["40’ Car Care Kit $125.00"]
                    },
                    // {
                    //     img: "ck6.png"
                    // }
                ]
            },
            {
                type: "hoses and hose socks",
                gallery: [
                    { 
                        img: "hs1.png",
                        info: ["Turbo Grip Hose", "35’ $195.00"]
                    },
                    // { 
                    //     img: "hs2.png",
                    //     info: ["E-Z Grip Hose", "35’ $210.00"]
                    // },
                    { 
                        img: "hs3.png",
                        info: ["Hose Sock with Zipper", "30’ $60.00", "35’ $65.00"]
                    }
                ]
            },
            {
                type: "economy tools",
                gallery: [
                    // { 
                    //     img: "et1.png",
                    //     info: ["Standard Dusting Brush $6.95"]
                    // },
                    // { 
                    //     img: "et2.png",
                    //     info: ["10” Bare Floor Brush $19.95"]
                    // },
                    // { 
                    //     img: "et3.png",
                    //     info: ["Standard Upholstery Brush $8.95"]
                    // },
                    // { 
                    //     img: "et4.png",
                    //     info: ["Crevice Tool $2.95"]
                    // },
                    // { 
                    //     img: "et5.png",
                    //     info: ["Turbo Cat Power Head $159.95"]
                    // },
                    { 
                        img: "et6.png",
                        info: ["Air-Driven Powerhead $59.95"],
                        ital: "Gentle cleaning for fine carpets"
                    }
                ]
            },
            {
                type: "premium luxe tools",
                gallery: [
                    { 
                        img: "pt1.png",
                        info: ["Luxe Dusting Brush $15.95"]
                    },
                    { 
                        img: "pt9.png",
                        info: ["Luxe Premium Brush Kit $59.95"]
                    },
                    // { 
                    //     img: "pt2.png",
                    //     info: ["14” Soft Floor Brush $29.95"]
                    // },
                    { 
                        img: "pt3.png",
                        info: ["12” Luxe Bare Floor Brush $25.95"]
                    },
                    { 
                        img: "pt4.png",
                        info: ["Luxe Crevice Tool $9.95"]
                    },
                    { 
                        img: "pt5.png",
                        info: ["Turbo Cat Zoom $195.00"]
                    },
                    { 
                        img: "pt6.png",
                        info: ["Luxe Carpet Brush $25.95"]
                    },
                    { 
                        img: "pt7.png",
                        info: ["Luxe Upholstery Tool $15.95"]
                    },
                    { 
                        img: "pt8.png",
                        info: ["Adjustable Wand", "Starting at $29.95"]
                    }
                ]
            },
            {
                type: "specialty cleaning tools",
                gallery: [
                    { 
                        img: "st1.png",
                        info: ["Microfiber Dust Mop $27.95"]
                    },
                    { 
                        img: "st2.png",
                        info: ["Microfiber Dust Mop Replacement Head $14.95"]
                    },
                    { 
                        img: "st3.png",
                        info: ["RugRat $79.95"]
                    },
                    { 
                        img: "st4.png",
                        info: ["Turbine Bumper $35.95"],
                        ital: "Wraps around power nozzles to protect moulding"
                    },
                    { 
                        img: "st5.png",
                        info: ["Pet Brush $19.95"]
                    }
                ]
            }
        ]
    }
}